export var InsertChildPlayerOtherTeam = {
  name: "player",
  component: "MainPanel",
  layout: "main-panel large align-center",
  mode: "visible",
  text: "player.select",
  showOn: [{ state: "editState", value: "child-insert-other", operator: "is" }],
  allowFlag: true,
  allowCancel: true,
  showDetails: { events: ["parent"] },
  children: [
    // Select Player
    {
      name: "player-select",
      component: "PlayerSelect",
      layout: "player-select",
      mode: "visible",
      showOn: [true],
      options: {
        currentEntityEvent: "parent",
        currentEntity: false,
        showBench: false,
        showCoach: false,
        excludeOtherEvents: false,
        excludePlayer: false,
        excludeFrom: "parent",
        calculateOnCourt: "after",
      },
      actionGroups: [
        {
          actions: [
            { action: "newEventId", value: null, type: "main" },
            {
              action: "sendEvent",
              value: "edit",
              type: "main",
            },
            { action: "calculateOnCourt" },
            { action: "nextState", value: null, type: "editState" },
          ],
          conditions: [],
        },
      ],
    },
  ],
};
